import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58d4485c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Alle Rezepte")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Kategorien")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Sammlungen")
const _hoisted_6 = {
  key: 0,
  class: "dropdown-secondary"
}

import { computed, ref } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileNav',
  setup(__props) {

const store = useStore()
const tags = computed(() => store.getters.getTags)
const showSecondary = ref(false);


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/recipes" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", {
        class: "dropdown",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showSecondary.value = !showSecondary.value))
      }, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/collections" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    (showSecondary.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), (tag) => {
            return (_openBlock(), _createElementBlock("li", {
              key: tag.slug
            }, [
              _createVNode(_component_router_link, {
                to: '/tag/' + tag.slug
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})